const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfilePicture(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0265487,0,0,0.0265487,-3.61062,-7.46018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1040,733C1040,876.23 973.38,1003.9 869.43,1086.71C792.22,1148.24 694.4,1185 588,1185C481.6,1185 383.78,1148.24 306.57,1086.71C202.62,1003.9 136,876.23 136,733C136,483.37 338.37,281 588,281C837.63,281 1040,483.37 1040,733Z",
    style: {
      fill: "rgb(201,211,214)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0265487,0,0,0.0265487,-3.61062,-7.46018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M778,632C778,736.934 692.934,822 588,822C483.066,822 398,736.934 398,632C398,527.066 483.066,442 588,442C692.934,442 778,527.066 778,632Z",
    style: {
      fill: "rgb(162,177,180)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0265487,0,0,0.0265487,-3.61062,-7.46018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M869.43,1086.71C792.22,1148.24 694.4,1185 588,1185C481.6,1185 383.78,1148.24 306.57,1086.71C343.12,965.93 455.29,878 588,878C720.71,878 832.88,965.93 869.43,1086.71Z",
    style: {
      fill: "rgb(162,177,180)",
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePicture);
export default __webpack_public_path__ + "static/media/profile-picture.4e01f89a34c2c4b424f76c98f96b6efa.svg";
export { ForwardRef as ReactComponent };